import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./HowItWorksSection.module.css";
import step1Img from "./assets/images/v4d_01.png";
import step2Img from "./assets/images/v4d_02.png";
import step3Img from "./assets/images/v4d_03.png";
import ScrollReveal from "../components/ScrollReveal";

const Step = ({ imgSrc, title, description, stepNumber, delay }) => (
  <ScrollReveal delay={delay}>
    <div className={styles.step} data-step={stepNumber}>
      <div className={styles.stepTop}>
        <div className={styles.stepNumber}>{stepNumber}</div>
        <div className={styles.stepImage}>
          <img src={imgSrc} alt={title} loading="lazy" />
        </div>
      </div>
      <div className={styles.stepBody}>
        <h3 className={styles.stepTitle}>{title}</h3>
        <p className={styles.stepDescription}>{description}</p>
      </div>
    </div>
  </ScrollReveal>
);

const HowItWorksSection = ({ intl }) => {
  return (
    <section id="como-funciona" className={styles.howItWorks}>
      <div className={styles.container}>
        <ScrollReveal>
          <div className={styles.sectionLabel}>
            <span className={styles.labelLine} />
            <FormattedMessage id="howItWorks.label" defaultMessage="Como funciona" />
            <span className={styles.labelLine} />
          </div>
          <h2 className={styles.sectionTitle}>
            <FormattedMessage id="howItWorks.title" />
          </h2>
          <p className={styles.sectionSubtitle}>
            <FormattedMessage id="howItWorks.subtitle" />
          </p>
        </ScrollReveal>

        <div className={styles.timeline}>
          <div className={styles.connectorTrack} aria-hidden="true">
            <div className={styles.connectorLine} />
          </div>

          <Step
            imgSrc={step1Img}
            title={intl.formatMessage({ id: "howItWorks.step1.title" })}
            description={intl.formatMessage({ id: "howItWorks.step1.description" })}
            stepNumber="01"
            delay={0}
          />
          <Step
            imgSrc={step2Img}
            title={intl.formatMessage({ id: "howItWorks.step2.title" })}
            description={intl.formatMessage({ id: "howItWorks.step2.description" })}
            stepNumber="02"
            delay={120}
          />
          <Step
            imgSrc={step3Img}
            title={intl.formatMessage({ id: "howItWorks.step3.title" })}
            description={intl.formatMessage({ id: "howItWorks.step3.description" })}
            stepNumber="03"
            delay={240}
          />
        </div>
      </div>
    </section>
  );
};

export default injectIntl(HowItWorksSection);
